import React from 'react';
import {
  oneOf,
  func,
} from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { connectAsync } from 'iguazu';
import { queryModuleWithData } from 'iguazu-holocron';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';

export const DefaultErrorPage = ({ code, ErrorMessage }) => <ErrorMessage code={code} />;

DefaultErrorPage.propTypes = {
  code: oneOf(['400', '404', '500']),
  ErrorMessage: func,
};

export const loadDataAsProps = ({ store: { dispatch } }) => ({
  ErrorMessage: () => dispatch(queryModuleWithData('axp-error-message')),
});

export function mapStateToProps(state, ownProps) {
  return {
    code: ownProps.route.code || state.getIn(['error', 'code']),
  };
}

// export const ComponentUnderTest = DefaultErrorPage;

const hocChain = compose(
  oneAppModuleWrapper('axp-error-message'),
  connect(mapStateToProps),
  connectAsync({ loadDataAsProps })
);

export default hocChain(DefaultErrorPage);
